export default __webpack_public_path__ + "static/media/_dkg_brust_rgb.41bf34df.svg";